import { type ReactNode } from 'react'

import { Image } from './Image'
import { asset } from '../lib/imageAssets'

/**
 * The seven partner marks the Figma frame draws (`59:4498` / `719:2357`), in
 * its order.
 *
 * SEVEN, NOT TEN, BY DECISION (2026-08-16) — ten marks in one row reads as
 * busy, and the row is a trust signal rather than a directory. SMSH, FOCOS and
 * SGMC have no mark in the file; if they are supplied later they do NOT get
 * appended. The closed 10 are listed in full on the results and search
 * surfaces, which is where a roster belongs.
 *
 * Names are spelled as `CLAUDE.md` spells them, not as the Figma layers are
 * named — three of those layer names are stale (`Bethel_Dental_Care 2` renders
 * the UGMC crest).
 */
const PARTNERS = [
  {
    name: 'Britannia Medical Centre',
    image: 'partners/britannia-medical-centre',
  },
  { name: 'International Maritime Hospital', image: 'partners/imah' },
  { name: 'LuccaHealth', image: 'partners/luccahealth' },
  { name: 'The Bank Hospital', image: 'partners/the-bank-hospital' },
  {
    name: 'Jubail Specialist Hospital',
    image: 'partners/jubail-specialist-hospital',
  },
  {
    name: 'Bethel Dental',
    image: 'partners/bethel-dental',
  },
  { name: 'University of Ghana Medical Centre', image: 'partners/ugmc' },
] as const

export function PartnerRow(): ReactNode {
  return (
    <section
      aria-labelledby="partners-h"
      className="px-4 py-6 sm:px-8 lg:px-12"
    >
      <h2
        id="partners-h"
        className="text-center font-display text-[18px] font-medium leading-7 text-ink-1"
      >
        Proud partners
      </h2>
      {/* The frame lays these out in one 55px-gapped row at 1440. A phone
          cannot hold seven marks on one line, and the ticket rules out a
          sideways scroller — a trust signal you have to drag is not one — so it
          wraps. */}
      <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 sm:gap-x-14">
        {PARTNERS.map((p) => (
          <li key={p.image}>
            {/* NOT decorative: no partner name is rendered beside its mark, so
                the mark is the only thing carrying it and the name has to reach
                a screen reader. `bg-none` kills `Image`'s gradient placeholder,
                which is right behind a photograph and wrong behind a logo with
                a transparent ground. */}
            <Image
              asset={asset(p.image)}
              alt={p.name}
              className="h-[30px] w-auto bg-none"
            />
          </li>
        ))}
      </ul>
    </section>
  )
}
